// Import the cookie library
//import Cookies from 'lib/js.cookie.min.mjs'

// The Main Site Object
let Site = {

    header    : document.querySelector('.header'),
    menu      : document.querySelector('.menu'),
    menuBtn   : document.querySelector('.menu-button'),
    menuItems : document.querySelectorAll('.menu-item'),

    // Init Function
    liftoff : () => {
        Site.onClickShowHideMenu()
    },

    // Show/Hide The Main Navigation
    onClickShowHideMenu : () => {
        Site.menuBtn.addEventListener('click' , () => {

            Site.menuBtn.classList.toggle('active')
            Site.menu.classList.toggle('active')
            Site.header.classList.toggle('active')

        })

        Site.menuItems.forEach(item => {
            item.addEventListener('click' , () => {
                Site.menuBtn.classList.toggle('active')
                Site.menu.classList.toggle('active')
                Site.header.classList.toggle('active')
            })
        })
    }



}

// Launch The Script
Site.liftoff()
